import { render, staticRenderFns } from "./VerificationFormPEP.vue?vue&type=template&id=1121aff2&"
import script from "./VerificationFormPEP.vue?vue&type=script&lang=js&"
export * from "./VerificationFormPEP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports